__turbopack_context__.v({
  "aiSummary": "service-detail-module__kVjE9a__aiSummary",
  "breadcrumb": "service-detail-module__kVjE9a__breadcrumb",
  "contactButton": "service-detail-module__kVjE9a__contactButton",
  "contactCard": "service-detail-module__kVjE9a__contactCard",
  "container": "service-detail-module__kVjE9a__container",
  "contentLayout": "service-detail-module__kVjE9a__contentLayout",
  "hero": "service-detail-module__kVjE9a__hero",
  "heroBackground": "service-detail-module__kVjE9a__heroBackground",
  "heroContent": "service-detail-module__kVjE9a__heroContent",
  "heroImage": "service-detail-module__kVjE9a__heroImage",
  "mainContent": "service-detail-module__kVjE9a__mainContent",
  "sidebar": "service-detail-module__kVjE9a__sidebar",
  "subtitle": "service-detail-module__kVjE9a__subtitle",
  "tag": "service-detail-module__kVjE9a__tag",
  "tagGrid": "service-detail-module__kVjE9a__tagGrid",
  "tagsSection": "service-detail-module__kVjE9a__tagsSection",
  "tagsTitle": "service-detail-module__kVjE9a__tagsTitle",
  "title": "service-detail-module__kVjE9a__title",
});
